export default "__VITE_ASSET__ddU2Ts4d__"